module.exports = {"360104002":"洪都街道","360104006":"京山街道","360104007":"三家店街道","360104008":"岱山街道","360104009":"徐家坊街道","360104100":"青云谱镇","360104400":"南昌昌南工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360104.json
// module id = 1151
// module chunks = 0